import React from 'react';
import { TrendingDown, Moon, Zap } from 'lucide-react';
export function Proof() {
  return <section className="py-20 bg-white" data-id="element-176">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-177">
        <div className="max-w-4xl mx-auto" data-id="element-178">
          <div className="bg-gradient-to-br from-green-900 to-green-800 rounded-3xl p-8 md:p-12 text-white shadow-2xl relative overflow-hidden" data-id="element-179">
            {/* Decorative background elements */}
            <div className="absolute top-0 right-0 -mr-20 -mt-20 w-64 h-64 rounded-full bg-green-700 opacity-50 blur-3xl" data-id="element-180"></div>
            <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-64 h-64 rounded-full bg-green-600 opacity-30 blur-3xl" data-id="element-181"></div>

            <div className="relative z-10" data-id="element-182">
              <div className="inline-block mb-6 px-4 py-1.5 rounded-full bg-green-800 border border-green-600 text-green-100 font-semibold text-sm tracking-wider uppercase" data-id="element-183">
                Resultados Comprobados
              </div>

              <h2 className="text-3xl md:text-4xl font-bold mb-8 text-white" data-id="element-184">
                El Cambio en 7 Días
              </h2>

              <p className="text-xl md:text-2xl text-green-50 mb-10 leading-relaxed font-medium" data-id="element-185">
                En la primera semana, el{' '}
                <span className="text-orange-400 font-bold text-3xl" data-id="element-186">90%</span>{' '}
                de los usuarios reporta que:
              </p>

              <div className="grid md:grid-cols-3 gap-6" data-id="element-187">
                <div className="bg-white/10 backdrop-blur-sm border border-white/20 p-6 rounded-2xl" data-id="element-188">
                  <Zap className="w-8 h-8 text-orange-400 mb-4" data-id="element-189" />
                  <p className="text-lg font-medium" data-id="element-190">
                    El "sopor" de la tarde desaparece por completo.
                  </p>
                </div>
                <div className="bg-white/10 backdrop-blur-sm border border-white/20 p-6 rounded-2xl" data-id="element-191">
                  <TrendingDown className="w-8 h-8 text-orange-400 mb-4" data-id="element-192" />
                  <p className="text-lg font-medium" data-id="element-193">
                    La inflamación en las manos y pies se reduce visiblemente.
                  </p>
                </div>
                <div className="bg-white/10 backdrop-blur-sm border border-white/20 p-6 rounded-2xl" data-id="element-194">
                  <Moon className="w-8 h-8 text-orange-400 mb-4" data-id="element-195" />
                  <p className="text-lg font-medium" data-id="element-196">
                    Logran dormir profundamente por primera vez en años.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}